import request from '@/utils/request'
import { AxiosResponse } from 'axios';

export const ApiService = {
  CheckStatus,
  SaveUserActivity,
  PickCard,
  UserRegister,
}




async function CheckStatus() : Promise<AxiosResponse> {

  return await request({
    url: 'GetCampaignInfo',
    method: 'post',
    
  });
}


export interface UserActivity {
  activity:string,
  deviceid?: string
}

async function SaveUserActivity(data:UserActivity) : Promise<AxiosResponse> {

  return await request({
    url: 'SaveUserActivity',
    method: 'post',
    data
    
  });
}



export interface GetCard {
  siteresponse:string | undefined,
}

async function PickCard(data:GetCard) : Promise<AxiosResponse> {

  return await request({
    url: 'PickACard',
    method: 'post',
    data
    
  });
}


export interface Register {
  "siteresponse":string | undefined,
  "registerid": string,
  "message": string,
  "firstname": string,
  "lastname": string,
}

async function UserRegister(data:Register) : Promise<AxiosResponse> {

  return await request({
    url: 'SaveGoldenCard',
    method: 'post',
    data,
  });
}



